import type { ToolMode } from "../editor/types";
import { Icon, type IconName } from "./Icon";

export const TOOLS: ReadonlyArray<{
  value: ToolMode;
  label: string;
  icon: IconName;
  shortcut: string;
}> = [
  { value: "select", label: "選択", icon: "select", shortcut: "V" },
  { value: "pen", label: "ペン", icon: "pen", shortcut: "B" },
  { value: "shape", label: "図形", icon: "shapes", shortcut: "R" },
  { value: "polygon", label: "多角形", icon: "polygon", shortcut: "L" },
  { value: "erase", label: "消しゴム", icon: "eraser", shortcut: "E" },
  { value: "restore", label: "AI復元", icon: "sparkles", shortcut: "A" },
];

interface ToolRailProps {
  tool: ToolMode;
  disabled?: boolean;
  onChange: (tool: ToolMode) => void;
}

export function ToolRail({ tool, disabled, onChange }: ToolRailProps) {
  return (
    <nav className="tool-rail" aria-label="ツール">
      {TOOLS.map((item) => (
        <button
          key={item.value}
          className={`tool-button ${tool === item.value ? "is-active" : ""}`}
          type="button"
          disabled={disabled}
          aria-pressed={tool === item.value}
          aria-keyshortcuts={item.shortcut}
          title={`${item.label} (${item.shortcut})`}
          onClick={() => onChange(item.value)}
        >
          <Icon name={item.icon} size={22} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
